<!-- Start Navbar Area -->
<div class="navbar-area">
    <div class="spacle-nav">
        <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" routerLink="/">
                    <img src="assets/img/logo.png" alt="logo">
                </a>

                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav">
                        <li class="nav-item dropdown">
                            <a routerLink="/" routerLinkActive="active" class="nav-link">Home</a>

                            <!--<ul class="dropdown-menu">
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link">Home One</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/home-two" routerLinkActive="active" class="nav-link">Home Two</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/home-three" routerLinkActive="active" class="nav-link">Home Three</a>
                                </li>
                            </ul>-->
                        </li>

                        <!--<li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <a routerLink="/about" routerLinkActive="active" class="nav-link">Sobre a LIA</a>
                        </li>

                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <a routerLink="/pricing" routerLinkActive="active" class="nav-link">Como Adquirir</a>
                        </li>-->

                        <!--<li class="nav-item dropdown">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown">
                                Pages <i class='bx bx-chevron-down'></i>
                            </a>

                            <ul class="dropdown-menu">
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/team" routerLinkActive="active" class="nav-link">Team</a>
                                </li>

                                <li class="nav-item dropdown">
                                    <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown">
                                        Features
                                    </a>

                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/features/features-1" routerLinkActive="active" class="nav-link">
                                                Features Style One
                                            </a>
                                        </li>

                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/features/features-2" routerLinkActive="active" class="nav-link">
                                                Features Style Two
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/auth/signin" routerLinkActive="active" class="nav-link">Log In</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/auth/signup" routerLinkActive="active" class="nav-link">Sign Up</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/faq" routerLinkActive="active" class="nav-link">FAQ</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/error-404" routerLinkActive="active" class="nav-link">404 Error</a>
                                </li>
                            </ul>
                        </li>-->

                        <!--<li class="nav-item dropdown">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown">
                                Blog <i class='bx bx-chevron-down'></i>
                            </a>

                            <ul class="dropdown-menu">
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/blog/blog-grid" routerLinkActive="active" class="nav-link">Blog Grid</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/blog/blog-with-right-sidebar" routerLinkActive="active" class="nav-link">
                                        Blog Right Sidebar
                                    </a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/blog/blog-details" routerLinkActive="active" class="nav-link">
                                        Blog Details
                                    </a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <a routerLink="/contact" routerLinkActive="active" class="nav-link">Contato</a>
                        </li>-->
                    </ul>

                    <div class="others-options">
                        <a href="https://api.whatsapp.com/send?phone=551137214418&text=Estou%20no%20site%20da%20LIA%20Assistente%20Virtual%20e%20gostaria%20de%20maiores%20informa%C3%A7%C3%B5es" class="default-btn">
                            <i class="bx bxs-hot"></i>Quero testar a LIA<span></span>
                        </a>

                        <a href="https://liaonline.com.br/" class="optional-btn">
                            <i class="bx bx-log-in"></i>Entrar na Minha Conta<span></span>
                        </a>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</div>
<!-- End Navbar Area -->
